import React from "react"
import { Skeleton } from "@material-ui/lab"
import {
	Grid
} from "@material-ui/core"

const ContactsFiltersSkeleton = () => {
	return (
		<Grid
			container
			spacing={2}
		>
			<Grid item xs={12}>
				<Skeleton variant="rect" height={85} style={ { borderRadius: "6px" } } />
			</Grid>
			<Grid item xs={12}>
				<Skeleton variant="rect" height={85} style={ { borderRadius: "6px" } } />
			</Grid>
			<Grid item xs={12}>
				<Skeleton variant="rect" height={85} style={ { borderRadius: "6px" } } />
			</Grid>

			<Grid item xs={12}>
				<Skeleton variant="rect" height={85} style={ { borderRadius: "6px" } } />
			</Grid>
		</Grid>

	)
}

export default ContactsFiltersSkeleton
